import { render, staticRenderFns } from "./DebugBar.vue?vue&type=template&id=144135d4&"
import script from "./DebugBar.vue?vue&type=script&lang=js&"
export * from "./DebugBar.vue?vue&type=script&lang=js&"
import style0 from "./DebugBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports